import React from "react";
import "../Features/features.css";

import feature1 from "../../assets/images/feature/beach-umbrella.png";
import feature2 from "../../assets/images/feature/deal.png";
import feature3 from "../../assets/images/feature/location.png";
import feature4 from "../../assets/images/feature/medal.png";
import feature5 from "../../assets/images/feature/location.png";
import feature6 from "../../assets/images/feature/medal.png";

import { Card, Col, Container, Row } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Features = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, arrows: false },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, arrows: false },
      },
    ],
  };

  const featureList = [
    {
      image: feature1,
      title: "Handpicked Experiences",
      des: "Carefully curated destinations for memorable journeys.",
    },
    {
      image: feature2,
      title: "Best Price Promise",
      des: "Enjoy competitive pricing with no hidden charges.",
    },
    {
      image: feature3,
      title: "Easy Discoveries",
      des: "Explore cities, nature, and culture without the hassle.",
    },
    {
      image: feature4,
      title: "Trusted by Travelers",
      des: "Thousands of happy travelers across the globe.",
    },
    {
      image: feature5,
      title: "24/7 Assistance",
      des: "Our travel experts are always available to help you.",
    },
    {
      image: feature6,
      title: "Flexible Planning",
      des: "Change plans easily with flexible booking options.",
    },
  ];

  return (
    <section className="feature-section slick_slider">
      <Container>
        <Row>
          <Col md="12">
            <Slider {...settings}>
              {featureList.map((feature, index) => (
                <Card className="feature-card" key={index}>
                  <div className="feature-icon">
                    <img src={feature.image} alt={feature.title} />
                  </div>
                  <Card.Title>{feature.title}</Card.Title>
                  <Card.Text>{feature.des}</Card.Text>
                </Card>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
